import { DispatchOrder } from "../dispatch-order/dispatch-order";
import { Ticket } from "../ticket/ticket";
import { User } from "../user/user";

export class Logevent {
    id: number;
    details: string;
    timestamp: Date;
    user: User;
    action: string;
    dispatchorder: DispatchOrder;
    ticket: Ticket;
}

export class LogeventCreate {
    id: number;
    details: string;
    timestamp: Date;
    user: number;
    action: string;
    dispatchorder: number;
    ticket: number;
}
